import myApi from '@/gavnoCode/ApiHandler';

export default {
  trackInst: function (data) {
    myApi.trackUrl(data,'instFunnel.php').then(data=>{
      if(process.env.NODE_ENV === 'development'){
        console.log('trackInst ' + data);
      }
    });
  },
  trackInputFocus: function (key) {
    myApi.singleRequest({
      action:'trackInputFocus',
      typeRequest:'palantir',
      data:{
        key:key,

      }
    }).then((res)=>{
      res['asd'] = 'asd';
    }).catch((res)=>{
      res['asd'] = 'asd';
    })
  },
  trackInputBlur: function (key,value) {
      myApi.singleRequest({
        action:'trackInputBlur',
        typeRequest:'palantir',
        data:{
          key:key,
          value:value
        }
      }).then((res)=>{
        res['asd'] = 'asd';
      }).catch((res)=>{
        res['asd'] = 'asd';
      })
  },
  trackAction: function (key,value) {
    myApi.singleRequest({
      action:'trackAction',
      typeRequest:'palantir',
      data:{
        key:key,
        value:value
      }
    }).then((res)=>{

      if (res != undefined){
        res['asd'] = 'asd';
      }else {
        res = {asd:'asd'};
      }
    }).catch((res)=>{
      if (res != undefined){
        res['asd'] = 'asd';
      }else {
        res = {asd:'asd'};
      }
    })
  },
  markAbTest: function () {
    myApi.singleRequest({
      action:'abTestMarkB',
      typeRequest:'palantir',
    }).then((res)=>{

      if (res != undefined){
        res['asd'] = 'asd';
      }else {
        res = {asd:'asd'};
      }
    }).catch((res)=>{
      if (res != undefined){
        res['asd'] = 'asd';
      }else {
        res = {asd:'asd'};
      }
    })
  }
}
